import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Form, FormContext, Input } from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import AverageUnitValueInput from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/components/InventoryInfo/components/AverageUnitValueInput';

const InteriorSqftRow = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);

  return (
    <Flex flex={1}>
      <Flex flex={1} flexDirection="column">
        <AverageUnitValueInput fieldKey="interiorSqft" />
      </Flex>
      <Flex flex={1} flexDirection="column" ml={4} mt={4.75}>
        <Form.Label>{t('forms:labels.customRooms')}</Form.Label>
        <Input
          w="100%"
          value={formState.customRooms || ''}
          placeholder={t('pages:portalShell.customRoomsPlaceholder') || ''}
          onChange={(event) =>
            stateHandlers[FormFields.CustomRooms](event.target.value)
          }
          $errorType={formErrors[FormFields.CustomRooms]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.CustomRooms]?.type}>
          {formErrors[FormFields.CustomRooms]?.message}
        </Form.Feedback>
      </Flex>
    </Flex>
  );
};

export default InteriorSqftRow;
